(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper')
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["p80-video-details"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const buildEmbed = (url) => {
      let parsed;
      try {
        parsed = new URL(url);
      } catch (error) {
        return null;
      }

      const host = parsed.hostname.replace(/^www\./, '');

      if (host === 'youtu.be') {
        const id = parsed.pathname.replace(/^\//, '');
        if (id) {
          return {
            provider: 'youtube',
            src: `https://www.youtube.com/embed/${id}?enablejsapi=1&autoplay=1`
          };
        }
      }

      if (host === 'youtube.com' || host === 'm.youtube.com' || host === 'music.youtube.com') {
        const id = parsed.searchParams.get('v');
        if (id) {
          return {
            provider: 'youtube',
            src: `https://www.youtube.com/embed/${id}?enablejsapi=1&autoplay=1`
          };
        }

        // p80: vertical videos are stored as /shorts/<id> links, which carry no `v` param. Same
        // match as assets/p80-video-hub-list.js, so a short plays in this modal instead of
        // falling back to opening YouTube in a new tab.
        const shortsMatch = parsed.pathname.match(/^\/shorts\/([^/]+)/);
        if (shortsMatch && shortsMatch[1]) {
          return {
            provider: 'youtube',
            src: `https://www.youtube.com/embed/${shortsMatch[1]}?enablejsapi=1&autoplay=1`
          };
        }
      }

      if (host === 'vimeo.com') {
        const id = parsed.pathname.split('/').filter(Boolean)[0];
        if (id) {
          return {
            provider: 'vimeo',
            src: `https://player.vimeo.com/video/${id}?autoplay=1`
          };
        }
      }

      return null;
    };

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-video-modal]');
      if (!trigger) {
        return;
      }

      event.preventDefault();
      const modal = document.querySelector(trigger.dataset.videoModal);
      if (!modal) {
        return;
      }

      const section = trigger.closest('.video-details');
      if (!section) {
        return;
      }

      const media = section.querySelector('.video-details__video[data-video-url]');
      const url = media ? media.dataset.videoUrl : '';
      const title = media ? media.dataset.videoTitle || '' : '';
      const embed = buildEmbed(url);

      if (!embed) {
        if (url) {
          window.open(url, '_blank', 'noopener');
        }
        return;
      }

      const host = modal.querySelector('deferred-media');
      if (!host) {
        return;
      }

      host.innerHTML = '';
      const iframe = document.createElement('iframe');
      iframe.src = embed.src;
      iframe.className = embed.provider === 'youtube' ? 'js-youtube' : 'js-vimeo';
      iframe.setAttribute('frameborder', '0');
      iframe.setAttribute('allow', 'autoplay; encrypted-media');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('title', title);
      host.appendChild(iframe);
      modal.show(trigger);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["p80-video-hub-featured"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const buildEmbed = (url) => {
      let parsed;
      try {
        parsed = new URL(url);
      } catch (error) {
        return null;
      }

      const host = parsed.hostname.replace(/^www\./, '');

      if (host === 'youtu.be') {
        const id = parsed.pathname.replace(/^\//, '');
        if (id) {
          return {
            provider: 'youtube',
            src: `https://www.youtube.com/embed/${id}?enablejsapi=1&autoplay=1`
          };
        }
      }

      if (host === 'youtube.com' || host === 'm.youtube.com' || host === 'music.youtube.com') {
        const id = parsed.searchParams.get('v');
        if (id) {
          return {
            provider: 'youtube',
            src: `https://www.youtube.com/embed/${id}?enablejsapi=1&autoplay=1`
          };
        }
      }

      if (host === 'vimeo.com') {
        const id = parsed.pathname.split('/').filter(Boolean)[0];
        if (id) {
          return {
            provider: 'vimeo',
            src: `https://player.vimeo.com/video/${id}?autoplay=1`
          };
        }
      }

      return null;
    };

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-video-modal]');
      if (!trigger) {
        return;
      }

      event.preventDefault();
      const modal = document.querySelector(trigger.dataset.videoModal);
      if (!modal) {
        return;
      }

      const section = trigger.closest('.vhf');
      if (!section) {
        return;
      }

      const media = section.querySelector('.vhf__lower-video[data-video-url]');
      const url = media ? media.dataset.videoUrl : '';
      const title = media ? media.dataset.videoTitle || '' : '';
      const embed = buildEmbed(url);

      if (!embed) {
        if (url) {
          window.open(url, '_blank', 'noopener');
        }
        return;
      }

      const host = modal.querySelector('deferred-media');
      if (!host) {
        return;
      }

      host.innerHTML = '';
      const iframe = document.createElement('iframe');
      iframe.src = embed.src;
      iframe.className = embed.provider === 'youtube' ? 'js-youtube' : 'js-vimeo';
      iframe.setAttribute('frameborder', '0');
      iframe.setAttribute('allow', 'autoplay; encrypted-media');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('title', title);
      host.appendChild(iframe);
      modal.show(trigger);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
